<template>
    <kt-row v-if="result">
        <kt-col lg="12" md="12" xs="12" class="mt-md-3 mt-5" v-if=result.bill_id>
            <kt-row>
                <kt-col lg="4" md="4"></kt-col>
                <kt-col lg="4" md="12" class="bg-white border-rounded rounded-3 shadow">
                    <kt-row>
                        <kt-col lg="4" md="4" xs="4">
                        </kt-col>
                        <kt-col lg="4" md="4" xs="4" class="mt-2 my-1">
                            <div class="text-center py-3">
                                <img src="../../src/views/pardakhtShakhsi/assets/ps-logo.jpg" class="img-thumbnail border-0">
                            </div>
                        </kt-col>
                    </kt-row>
                </kt-col>
                <kt-col lg="2" md="4"></kt-col>
            </kt-row>
        </kt-col>
        <kt-col lg="12" md="12" xs="12" v-if=result.bill_id>
            <kt-row style="margin-top: 1px">
                <kt-col lg="4"></kt-col>
                <kt-col lg="4" class="bg-white h-100 pb-5 border-rounded rounded-3 shadow">
                    <kt-col lg="12" class="title mt-md-1">
                        <div>
                            <h3 class="font-weight-bold">
                                {{ $t('bill-service.receipt') }}
                            </h3>
                            <h6>
                                {{ $t('bill-service.receipt_text') }}
                            </h6>
                        </div>
                    </kt-col>
                </kt-col>
                <kt-col lg="2"></kt-col>
            </kt-row>
        </kt-col>
        <kt-col lg="12" md="12" xs="12" v-if=result.bill_id>
            <kt-row style="margin-top: 1px" class="text-center">
                <kt-col lg="4">
                </kt-col>
                <kt-col lg="4" class="bg-white border-rounded rounded-3 shadow">
                    <kt-col lg="12" class="mx-3 py-2">
                        <h5 class="font-weight-bold text-left">
                            {{ $t('bill-service.bill_id') }}
                        </h5>
                        {{result.bill_id}}
                    </kt-col>
                </kt-col>
                <kt-col lg="2">

                </kt-col>
            </kt-row>
        </kt-col>
        <kt-col lg="12" md="12" xs="12" v-if=result.pay_id>
            <kt-row style="margin-top: 1px" class="text-center">
                <kt-col lg="4" >
                </kt-col>
                <kt-col lg="4" class="bg-white border-rounded rounded-3 shadow">
                    <kt-col lg="12" class="mx-3 py-2">
                        <h5 class="font-weight-bold text-left">
                            {{ $t('bill-service.pay_id') }}
                        </h5>
                        {{result.pay_id}}
                    </kt-col>
                </kt-col>
                <kt-col lg="2">

                </kt-col>
            </kt-row>
        </kt-col>
        <kt-col lg="12" md="12" xs="12" v-if=result.amount>
            <kt-row style="margin-top: 1px" class="text-center">
                <kt-col lg="4">
                </kt-col>
                <kt-col lg="4" class="bg-white border-rounded rounded-3 shadow">
                    <kt-col lg="12" class="mx-3 py-2">
                        <h5 class="font-weight-bold text-left">
                            {{ $t('bill-service.amount_bill') }}
                        </h5>
                        {{result.amount  }}
                    </kt-col>
                </kt-col>
                <kt-col lg="2">

                </kt-col>
            </kt-row>
        </kt-col>
        <kt-col lg="12" md="12" xs="12" v-if=result.order_id>
            <kt-row style="margin-top: 1px" class="text-center">
                <kt-col lg="4">
                </kt-col>
                <kt-col lg="4" class="bg-white border-rounded rounded-3 shadow">
                    <kt-col lg="12" class="mx-3 py-3">
                        <h5 class="font-weight-bold text-left">
                            {{ $t('bill-service.trace_code') }}
                        </h5>
                         {{result.order_id}}
                    </kt-col>
                </kt-col>
                <kt-col lg="2">

                </kt-col>
            </kt-row>
        </kt-col>
        <kt-col lg="12" md="12" xs="12" v-if=result.bill_type>
            <kt-row style="margin-top: 1px" class="text-center">
                <kt-col lg="4">
                </kt-col>
                <kt-col lg="4" class="bg-white border-rounded rounded-3 shadow">
                    <kt-col lg="12" class="mx-3 py-2">
                        <h5 class="font-weight-bold text-left">
                            {{ $t('bill-service.type_bill') }}
                        </h5>
                        {{result.bill_type}}
                    </kt-col>
                </kt-col>
                <kt-col lg="2">

                </kt-col>
            </kt-row>
        </kt-col>
        <kt-col lg="12" md="12" xs="12" v-if=result.state>
            <kt-row style="margin-top: 1px" class="text-center">
                <kt-col lg="4"></kt-col>
                <kt-col lg="4" class="bg-white border-rounded rounded-3 shadow pb-3">
                    <kt-col lg="12" class="mx-3 py-2">
                        <h5 class="font-weight-bold text-left">
                            {{ $t('bill-service.bill_status') }}
                        </h5>
                         {{result.state}}
                    </kt-col>
                </kt-col>
                <kt-col lg="2"></kt-col>
            </kt-row>
        </kt-col>
        <kt-col lg="12" md="12" xs="12">
    </kt-col>
    </kt-row>
    <kt-row v-else>
        <kt-col lg="12" md="12" xs="12" class="mt-md-3 mt-5">
            <kt-row>
                <kt-col lg="4" md="4"></kt-col>
                <kt-col lg="4" md="12" class="bg-white border-rounded rounded-3 shadow">
                    <kt-row>
                        <kt-col lg="4" md="4" xs="4">
                        </kt-col>
                        <kt-col lg="4" md="4" xs="4" class="mt-2 my-1">
                            <div class="text-center py-3">
                                <img src="../../src/views/pardakhtShakhsi/assets/ps-logo.jpg" class="img-thumbnail border-0">
                            </div>
                        </kt-col>
                    </kt-row>
                </kt-col>
                <kt-col lg="2" md="4"></kt-col>
            </kt-row>
        </kt-col>
        <kt-col lg="12" md="12" xs="12">
            <kt-row style="margin-top: 1px">
                <kt-col lg="4"></kt-col>
                <kt-col lg="4" class="bg-white h-100 pb-5 border-rounded rounded-3 shadow">
                    <kt-col lg="12" class="title mt-md-1">
                        <div>
                            <h3 class="font-weight-bold">
                                {{ $t('bill-service.not_found') }}
                            </h3>
                        </div>
                    </kt-col>
                </kt-col>
                <kt-col lg="2"></kt-col>
            </kt-row>
        </kt-col>
    </kt-row>
</template>

<script>


import { ApiUrl } from '@/common/api.service'
import axios from "axios";
import { i18n } from '@/plugins/i18n'
import toastr from "toastr";


export default {
    name: "ReceiptBillservices",
    data() {
        return {
            result: {},
            'order_id': this.$route.params.order_id
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    async created() {
        axios({
            url: ApiUrl.path(`bill-services/receipt/${this.order_id}`),
            method: 'GET',
        }).then((response) => {
            this.result = response.data
        }).catch(({response}) => {
            this.toastr.error(i18n.t('message.an_error_accord'))
        }).finally(() => {
        })
    },
}
</script>
<style scoped>
.title {
    border-right: 3px solid #f1c40f;
    border-bottom: none;
}

</style>